import { render } from "./DashboardUnidades.vue?vue&type=template&id=1c401f3f&scoped=true"
import script from "./DashboardUnidades.vue?vue&type=script&lang=js"
export * from "./DashboardUnidades.vue?vue&type=script&lang=js"

import "./DashboardUnidades.vue?vue&type=style&index=0&id=1c401f3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c401f3f"]])

export default __exports__